















import { Component, Vue, Watch ,Prop} from "vue-property-decorator"
import parts3 from "./parts3.vue"
import parts4 from "./parts4.vue"

@Component({
	components: {
		parts3,
		parts4
	}
})
export default class Default extends Vue {
	@Prop(String) specialZoneName!: String

	@Watch("name")
	getWatchValue(newVal: string, oldVal: string) {
		console.log(newVal, oldVal)
	}

	// created() {}

	// mounted() {}
}
